<template>
  <header class="header">
    <nav
      class="navbar navbar-fixed-top navbar-inner navbar-expand-lg navbar-light"
    >
      <a class="navbar-brand" href="/">
        <img src="../assets/logo.png" alt="..." width="200" />
       
        <div class="absolute-version"> <span>v{{ getAppVersion }} </span>
        <span v-if="userInfo && userInfo.id">( {{ userInfo.email }}
        <span v-if="userRole">/ {{ userRole | translate }} )</span></span>
        </div>
      </a>
      <div class="role-info"></div>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul v-if="access && access === 'admin'" class="navbar-nav ml-auto">
          <!-- <li :class="[activeButton === 0 ? 'active' : '', 'nav-item']">
            <a class="nav-link" href="/admin-home">{{
              "lng_menu_home" | translate
            }}</a>
          </li>
          <li :class="[activeButton === 1 ? 'active' : '', 'nav-item']">
            <a class="nav-link" href="/admin-devices">{{
              "lng_menu_boxsett" | translate
            }}</a>
          </li> -->
          <li
            v-if="getUserToken"
            @click="logoutAll"
            :class="[activeButton === 4 ? 'active' : '', 'nav-item']"
          >
            <a class="nav-link" href="#" tabindex="-1" aria-disabled="true">{{
              "lng_menu_logout" | translate
            }}</a>
          </li>
          <li
            v-else
            @click="logoutAll"
            :class="[activeButton === 4 ? 'active' : '', 'nav-item']"
          >
            <a class="nav-link" href="#" tabindex="-1" aria-disabled="true">{{
              "lng_login_text" | translate
            }}</a>
          </li>
          <div style="max-width: 200px">
            <v-select
              :items="langs"
              @change="changeLanguage()"
              v-model="selectedLanguage"
            >
              <template v-slot:selection="{ item, index }">
                <country-flag :country="item.flag" size="normal" />
                <span class="flags pl-2">{{ item.name }}</span>
              </template>
              <template v-slot:item="{ item, index }">
                <country-flag :country="item.flag" size="normal" />
                <span class="flags pl-2">{{ item.name }}</span>
              </template>
            </v-select>
          </div>
        </ul>
      </div>
    </nav>
  </header>
  
</template>
<script>
import router from "../router";
import { languages, appVersion, langFileVersion } from "../common/Constant.js";
import CountryFlag from "vue-country-flag";
import { getTextBasedOnRoles } from "../common/HelperFunctions";

export default {
  name: "HeaderComp",
  components: {
    CountryFlag,
  },
  data: () => ({
    langs: languages,
    selectedLanguage: undefined,
    userRole: "",
    langVersion: langFileVersion
  }),
  props: {
    activeButton: {
      type: Number,
      default: 0,
    },
    access: {
      type: String,
      default: "user",
    },
    userInfo: {
      type: Object,
      default: () => {},
    },
  
  },
  // watch: {
  //   userInfo(newVal) {
  //     if(newVal && newVal.id)
  //       this.userRole = getTextBasedOnRoles(newVal);
  //   }
  // },
  computed: {
    getAppVersion() {
      return appVersion;
    },
    getUserToken() {
      return sessionStorage.userToken
    }
  },
  mounted() {
    if(this.$route.params.lang){
      let selectedLang = languages.find(e => e.lang === this.$route.params.lang);
      this.selectedLanguage = selectedLang ? selectedLang : languages[1];
      window.selectedLang = require(`../../public/locales/${this.selectedLanguage.lang + this.langVersion}.json`);
    } else {
      let langName = localStorage.getItem("language");
      let filtered = languages.find((e) => e.lang === langName);
      this.selectedLanguage = filtered ? filtered : languages[1];
    }

    let auth = localStorage.getItem("authLevel");
    if(auth == 0){
      this.userRole = "lng_dealer_txt"
    }
    if(auth == 1){
      this.userRole = "lng_user_txt"
    }
    if(auth == 3){
      this.userRole = "lng_admin_txt"
    }
  },
  methods: {
    logoutUser() {
      localStorage.removeItem("userToken");
      localStorage.removeItem("userData");
      router.push("/login");
    },
    logoutDealer() {
      localStorage.removeItem("dealerToken");
      localStorage.removeItem("dealerData");
      router.push("/login");
    },
    logoutAdmin() {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminData");
      router.push("/login");
    },
    logoutAll() {
      var myItem = localStorage.getItem("vue-cookie-accept-decline-myPanel1");
      localStorage.clear();
      sessionStorage.clear();
      localStorage.setItem("vue-cookie-accept-decline-myPanel1", myItem);

      router.push("/login");
    },
    async changeLanguage() {
      localStorage.setItem("language", this.selectedLanguage.lang);
      window.selectedLang = require(`../../public/locales/${this.selectedLanguage.lang + this.langVersion}.json`);
      this.$emit('update')
      if(this.$route.name === "Dealers"){
        let params = this.$route.params;
        router.push({ path: `/view/dealers/${params?.centerLoc}/${this.selectedLanguage.lang}` })
      }
      // window.I18n = new I18n(this.selectedLanguage.lang);
    },
  },
};
</script>
<style scoped>
.v-menu__content {
  z-index: 9999 !important;
}
.absolute-version {
  height:20px !important;
  font-size: 0.8rem;
}

</style>